<script lang="ts">
import { AppFormatTimeComponent } from "./app-format-time.ts";
export default AppFormatTimeComponent;
</script>

<template>
    <app-format-date :value="value" :format="format" />
</template>
